import * as XLSX from "xlsx";
import { formatRevenueOrderDate, RevenueOrder } from "./revenueData";

export function createRevenueWorkbook(orders: RevenueOrder[]) {
  const rows = orders.map(order => ({
    "Order ID": order.orderId,
    "Order Date": formatRevenueOrderDate(order.orderDate),
    "Sales Channel": order.source,
    "Net Revenue (PHP)": order.amountCents / 100,
    Status: order.status,
  }));
  const worksheet = XLSX.utils.json_to_sheet(rows);

  orders.forEach((order, index) => {
    const address = XLSX.utils.encode_cell({ r: index + 1, c: 0 });
    const cell = worksheet[address];
    if (cell) {
      cell.t = "s";
      cell.v = order.orderId;
      cell.z = "@";
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales");
  return workbook;
}

export function revenueFilename(quarter: string) {
  return `ph-sales-${quarter.toLowerCase().replace(" ", "-")}.xlsx`;
}
